import { ResourceDefinition, ResourceSections } from 'src/types';

export const DefaultDataPackagesResource: ResourceDefinition = {
  name: 'default_data_packages',
  section: ResourceSections.DATA_PACKAGES,
};
